// extracted by mini-css-extract-plugin
export default {"TableView":"EmployeeTable_TableView__w88CG","Cell":"EmployeeTable_Cell__TsB-f","Paper":"EmployeeTable_Paper__EtjBu"};